export const getGAClientId = (): string | undefined =>
  typeof window.ga !== 'undefined' && typeof window.ga.getAll !== 'undefined'
    ? window.ga.getAll()[0]?.get('clientId')
    : undefined;
